import { getISOWeek } from 'date-fns';

// Define interface for token claims
export interface ExtendedIdTokenClaims {
    roles?: string[];
    [key: string]: unknown;
}

// Function to get ISO week number
export const getCurrentWeekNumber = (date: Date): number => {
    return getISOWeek(date);
}
